const UsersStatistic = () => import('@/modules/Print/Statistics/UsersStatistic.vue');

const Reports = () => import(/* webpackChunkName: "Reports" */ 'RootDir/modules/Print/Reports.vue');

const Forms = () => import(/* webpackChunkName: "Forms" */ 'RootDir/modules/Print/Forms.vue');

const Statistics = () =>
  import(/* webpackChunkName: "Statistics" */ 'RootDir/modules/Print/Statistics/Statistics.vue');

/* DUMB COMPONENTS */
// Тупой компонент в котором только вложен router-view
const RouterViewComponent = () =>
  import(
    /* webpackChunkName: "RouterViewComponent" */ 'RootDir/shared_components/RouterViewComponent.vue'
  );
/* END DUMB COMPONENTS */

export default [
  {
    path: 'reports',
    name: 'print-reports',
    component: Reports,
  },
  {
    path: 'forms',
    name: 'print-forms',
    component: Forms,
  },
  {
    path: 'statistics',
    component: RouterViewComponent,
    children: [
      {
        path: 'hunting-tickets',
        name: 'hunting-tickets-statistics',
        component: Statistics,
      },
      {
        path: 'hunting-applications',
        name: 'hunting-applications-statistics',
        component: Statistics,
      },
      {
        path: 'users',
        name: 'users-statistics',
        component: UsersStatistic,
      },
    ],
  },
];
